import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {DataSource, IListItemState} from '@mintdata/mint-kit/api/models/List';
import {ContextMenu, IContextMenuItem, ToggleOn} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpaceSelector.less');
const cx = classnames.bind(styles);

interface ISpaceSelectorProps
{
    className?:string;
    selectedItemClassName?:string;
    titlePrefix?:string;
    titlePostfix?:string;
    showAllItem?:boolean;
    togglerId?:string;
    selectedItem?:Project;
    onSelectItem?:(item:ISpaceSelectortMenuItem)=>void;
}

interface ISpaceSelectorState
{
    isOpened:boolean;
}

export interface ISpaceSelectortMenuItem extends IContextMenuItem
{
    spaceId?:number;
}

@observer
export class SpaceSelector extends React.Component<ISpaceSelectorProps, ISpaceSelectorState>
{
    @computed
    private get _menuItems():Array<ISpaceSelectortMenuItem>
    {
        let menuItems:Array<ISpaceSelectortMenuItem> = rootState.data.projects.map((project:Project) =>
        {
            return {
                label: project.name,
                spaceId: project.id,
            };
        });

        if( this.props.showAllItem )
        {
            menuItems.unshift({
                isSeparator: true,
            });

            menuItems.unshift({
                label: 'All Spaces',
                spaceId: null,
            });
        }

        return menuItems;
    }

    public constructor(props:any)
    {
        super(props);

        this.state = {
            isOpened: false
        };
    }

    private _onShow = () => this.setState({isOpened: true});

    private _onHide = () => this.setState({isOpened: false});

    @computed
    private get _currentSpace():Project
    {
        const {applicationsSelectedSpaceId} = rootState.ui.mainPage;

        return rootState.data.projects.find(({id}) => id == applicationsSelectedSpaceId);
    }

    @bind
    private _menuProvider():DataSource<ISpaceSelectortMenuItem>
    {
        const {applicationsSelectedSpaceId} = rootState.ui.mainPage;

        return this._menuItems.map((item:ISpaceSelectortMenuItem) =>
        {
            if( item.isSeparator ) return item;

            const isSelected = item.spaceId === applicationsSelectedSpaceId;

            return {
                ...item,
                isSelected,
                handler: () => {
                    if( this.props.onSelectItem )
                        this.props.onSelectItem(item);
                    else
                        this._selectMenuItem(item);
                }
            } as ISpaceSelectortMenuItem;
        });
    }

    @action
    private _selectMenuItem(item:ISpaceSelectortMenuItem)
    {
        rootState.ui.mainPage.applicationsSelectedSpaceId = item.spaceId;
    }

    @bind
    private _renderSheetsMenuItem({label, isSeparator}:ISpaceSelectortMenuItem,
                                  {isSelected}:IListItemState,
                                  {menuItem, separator}:IStyles):JSX.Element
    {
        if( isSeparator ) return (
            <div className={cx(separator)} />
        );

        return (
            <div className={cx(styles.menuItem, menuItem)}>

                <div className={styles.menuItemIcon}>
                    {
                        isSelected &&
                        <MDIcon
                            name={MDIcons.common.Checkmark}
                            size={MDIconSize.medium16}
                            className={styles.icon}
                        />
                    }
                </div>

                <div className={styles.menuItemLabel}>
                    {label}
                </div>

            </div>
        );
    }

    private _getSelectedSpaceName():string
    {
        if( this.props.selectedItem )
            return this.props.selectedItem.name;
        
        if( this._currentSpace )
            return this._currentSpace.name;
        
        if( this._menuItems.length )
            return this._menuItems[0].label.toString();

        return '';
    }

    public componentDidMount()
    {
        if( !this.props.selectedItem && !this._currentSpace )
            this.props.onSelectItem && this._menuItems.length && this.props.onSelectItem(this._menuItems[0]);   
    }

    public render():JSX.Element
    {
        const togglerId = this.props.togglerId || 'spacesSelector';

        let selectedSpaceName:string = this._getSelectedSpaceName();

        const {isOpened} = this.state;

        return (
            <div className={cx(styles.base, this.props.className)} id={togglerId}>
                <ContextMenu
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[togglerId]}
                    popupAnchor={PopupAnchor.LeftTop}
                    sourceAnchor={SourceAnchor.LeftBottom}
                    popupClassName={styles.menuPopup}
                    dataSource={this._menuProvider}
                    itemRenderer={this._renderSheetsMenuItem}
                    onShow={this._onShow}
                    onHide={this._onHide}
                    contentClassName={styles.popupContent}
                    closeSelfOnlyOnSelectItem
                >
                    <div className={cx(styles.handler, {isOpened})}>
                        <div className={cx(styles.handlerText)}>
                            {this.props.titlePrefix || ''}
                            <span className={cx(this.props.selectedItemClassName)}>
                                {selectedSpaceName}
                            </span>
                            {this.props.titlePostfix || ''}
                        </div>
                        <MDIcon
                            className={cx(styles.menuIcon, {isOpened})}
                            name={MDIcons.common.ChevronRight}
                        />
                    </div>
                </ContextMenu>
            </div>
        );
    }
}
